exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.color-repeater > div{\n\tdisplay: inline-block;\n}\n.add-color-picker-button {\n\tdisplay: block!important;\n}\n.ColorPicker-container{\n\tdisplay: inline-block;\n\tmargin: 15px;\n}\n.ColorPicker-container .open-DColorPicker{\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n.ColorPicker-container .button.is-danger{\n\tvertical-align: middle;\n}\n", ""]);

// exports
